import React from 'react';
import PropTypes from 'prop-types';

// Components
import { FilterDate, FilterGroups, DownloadButton } from '@components';

import { FiltersContainer } from './../Styled';

const ChartHeader = ({ getFilterDate, getFilterGroups, filterDateKey, filterGroupsKey, onDownload }) => (
  <FiltersContainer>
    <div>
      <FilterDate filter={filterDateKey} getFilterDate={getFilterDate} />
      <FilterGroups
        filter={filterGroupsKey}
        getFilterGroups={getFilterGroups}
      />
    </div>
    {onDownload ? <DownloadButton onDownload={onDownload} variant="text" /> : null}
  </FiltersContainer>
);

ChartHeader.propTypes = {
  getFilterDate: PropTypes.func.isRequired,
  getFilterGroups: PropTypes.func.isRequired,
  filterDateKey: PropTypes.string.isRequired,
  filterGroupsKey: PropTypes.string.isRequired,
  onDownload: PropTypes.func,
};

ChartHeader.defaultProps = {
  onDownload: null,
};

export default ChartHeader;
export { ChartHeader };
